import { boot } from "quasar/wrappers";
import {
  isPublicLinkPath,
  isUniversalLinkPath,
  resolveDeepLinkPath,
} from "src/utils/deepLink";

export default boot(({ app, router }) => {
  document.addEventListener("deviceready", () => {
    if (typeof window.universalLinks !== "undefined") {
      window.universalLinks.subscribe("launchedAppFromLink", (eventData) => {
        if (!eventData || !eventData.path) return;

        // The AASA claims every path on the host, so a verification link opens
        // the app rather than the browser once it is installed. Route it to the
        // same public page the browser would have shown.
        if (isPublicLinkPath(eventData.path)) {
          router.push({ path: eventData.path });
          return;
        }

        if (isUniversalLinkPath(eventData.path))
          router.push({ path: resolveDeepLinkPath(eventData.path) });
      });
    }
  });
});
